import React, { useEffect, useState } from 'react';
import ListTable from 'components/table/ListTable';
import RenderButtons from 'components/table/RenderButtons';
import { useUIUtils } from 'hooks/useUIUtils';
import { getDataSession } from 'views/Utils/Common';
import { BotonNuevo, cargar, siNo, sucursalActual } from '../comun';

const List = ({ match }) => {
    const { path } = match;
    const { changeGlobalTitle } = useUIUtils();
    const [usuarios, setUsuarios] = useState([]);

    useEffect(() => {
        changeGlobalTitle('Cajeros', 'Listado de cajeros del punto de venta.');
        cargar(`usuarios/GetList?empresa_id=${getDataSession('empresa')}&sucursal_id=${sucursalActual()}&paginas=0&totalXpagina=200&busqueda=`).then(setUsuarios);
    }, [changeGlobalTitle]);

    const nombreUsuario = (id) => usuarios.find((item) => item.id === id)?.nombre || id;

    const columns = [
        { renderCell: RenderButtons, headerName: '', maxWidth: 20, path: path, opciones: 'editar' },
        {
            field: 'id', headerName: 'Id', maxWidth: 70, renderCell: (params) => (
                <a href={`${path}/edit/${params.row.id}`}>{params.value}</a>)
        },
        { field: 'usuario_Id', headerName: 'Usuario', minWidth: 200, valueGetter: (value) => nombreUsuario(value) },
        { field: 'operar_Cajas', headerName: 'Opera cajas', minWidth: 120, valueGetter: (value) => siNo(value) },
        { field: 'abrir_Cajas', headerName: 'Abre cajas', minWidth: 120, valueGetter: (value) => siNo(value) },
        { field: 'reportes_Del_Dia', headerName: 'Reportes del dia', minWidth: 140, valueGetter: (value) => siNo(value) }
    ];

    return (
        <div className='container-fluid'>
            <div className='col-md-12'>
                <BotonNuevo to={`${path}/add`} />
            </div>
            <div className='col-md-12'>
                <ListTable
                    columns={columns}
                    path={path}
                    hideSearch
                    url={`pv/PvCajeros/GetList?usuario_id=0&sucursal_id=${sucursalActual()}`}
                />
            </div>
        </div>
    );
};

export { List };
